var map = {
	"./_logo": "GdqY",
	"./_logo.png": "GdqY",
	"./destination": "oOZT",
	"./destination.png": "oOZT",
	"./logo": "jW0x",
	"./logo-header": "Iig0",
	"./logo-header.png": "Iig0",
	"./logo.png": "jW0x",
	"./taxi": "vrly",
	"./taxi-request": "HtxJ",
	"./taxi-request.png": "HtxJ",
	"./taxi.png": "vrly",
	"./user": "BHQV",
	"./user.png": "BHQV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ETuK";


//////////////////
// WEBPACK FOOTER
// ./resources/holataxi/img ^\.\/.*$
// module id = ETuK
// module chunks = 1